import { DirectiveOptions } from 'vue'
import { coreUtils } from '@ustra/core'

const defaultOption = {
  handler: null,
  el: null,
}

const scrollDirective: DirectiveOptions = {
  inserted: (el, binding) => {
    let option = null
    if (typeof binding.value === 'function') {
      option = coreUtils.deepMerge<any>({}, defaultOption, {
        handler: binding.value,
      })
    } else if (typeof binding.value === 'object') {
      option = coreUtils.deepMerge<any>({}, defaultOption, binding.value)
    } else {
      throw new TypeError('scrollDirective arguments is wrong.')
    }

    const handler = e => option.handler(e)
    document.addEventListener('scroll', handler, true)

    // @ts-ignore
    el.___scroll = handler
  },
  unbind: el => {
    // @ts-ignore
    if (!el.___scroll) return
    const app = document
    // @ts-ignore
    app && app.removeEventListener('scroll', el.___scroll, true)
    // @ts-ignore
    delete el.___scroll
  },
}

export { scrollDirective }
export default scrollDirective
